import { inject, injectable } from 'inversify';
import ProductsRepository from 'src/features/products/data/ProductsRepository';

interface GetAllProductsByStoreUseCaseParams {
  storeSlug: string;
  limit?: number;
  offset?: number;
  token?: string;
}

@injectable()
class GetAllProductsByStoreUseCase {
  @inject(ProductsRepository) private productsRepository!: ProductsRepository;

  async execute(params: GetAllProductsByStoreUseCaseParams) {
    return await this.productsRepository.getStoreStock(params);
  }
}

export default GetAllProductsByStoreUseCase;
